var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_20199)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.68687 0.0211644C5.76234 -0.022406 5.85884 0.00345324 5.90241 0.0789226L7.13297 2.2104C8.19823 1.24853 9.63725 0.601743 11.2472 0.44647H12.7527C14.3628 0.601796 15.8018 1.24865 16.8671 2.21057L18.0978 0.0789187C18.1414 0.00345059 18.2379 -0.0224059 18.3133 0.0211666C18.3888 0.0647392 18.4147 0.161241 18.3711 0.236709L17.1023 2.43422C18.1154 3.44833 18.735 4.76746 18.7551 6.21223H5.24475C5.26487 4.76733 5.88458 3.44815 6.89769 2.43405L5.62911 0.236705C5.58554 0.161236 5.6114 0.0647348 5.68687 0.0211644ZM9.98763 3.53215C9.98889 3.95018 9.64291 4.29005 9.21478 4.29121C8.78686 4.29226 8.43889 3.95439 8.43763 3.53636V3.53215C8.43647 3.11401 8.78244 2.77424 9.21047 2.77309C9.63839 2.77193 9.98636 3.1097 9.98763 3.52794V3.53215ZM15.7727 3.53215C15.774 3.95018 15.428 4.29005 14.9999 4.29121C14.572 4.29226 14.224 3.95439 14.2227 3.53636V3.53215C14.2216 3.11401 14.5676 2.77424 14.9956 2.77309C15.4235 2.77193 15.7715 3.1097 15.7727 3.52794V3.53215Z",
    fill: "#A4C639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.19173 7.02409C5.19173 6.96603 5.19604 6.90859 5.20098 6.85179H18.8013C18.8062 6.90838 18.8083 6.96603 18.8083 7.02409V16.7603C18.8083 17.8073 17.9795 18.6509 16.9505 18.6509H16.8773V22.502C16.8773 23.3293 16.2066 23.9999 15.3792 23.9999C14.552 23.9999 13.8813 23.3293 13.8813 22.502V18.6509H10.1189V22.502C10.1189 23.3293 9.4482 23.9999 8.62087 23.9999C7.79364 23.9999 7.12294 23.3293 7.12294 22.502V18.6509H7.04941C6.02053 18.6509 5.19173 17.8074 5.19173 16.7603V7.02409Z",
    fill: "#A4C639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78484 7.71826C3.61207 7.71826 4.28277 8.38897 4.28277 9.2163V15.6425C4.28277 16.4698 3.61207 17.1405 2.78484 17.1405C1.95751 17.1405 1.2868 16.4698 1.2868 15.6426V9.2164C1.2867 8.38907 1.9574 7.71826 2.78484 7.71826Z",
    fill: "#A4C639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2154 7.71826C22.0426 7.71826 22.7133 8.38897 22.7133 9.2163V15.6425C22.7133 16.4698 22.0426 17.1405 21.2154 17.1405C20.388 17.1405 19.7173 16.4698 19.7173 15.6426V9.2164C19.7173 8.38907 20.388 7.71826 21.2154 7.71826Z",
    fill: "#A4C639"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_20199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/Android.82719d16bf480dc4e81a1da15d782744.svg";
export { ForwardRef as ReactComponent };